import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header";

import HeroSection from "./components/HeroSection";

import AboutSection from "./components/AboutSection";
import Resume from "./components/Resume";
import Projects from "./components/Projects";
import Services from "./components/Services";
import Contact from "./components/Contact";
import RetroBackground from "./components/RetroBackground";

function App() {
  const [isMobileNavActive, setIsMobileNavActive] = useState(false);

  return (
    <Router>
      <div style={{ backgroundColor: "#f7f7f7", overflow: "hidden" }}>
        <Header />

        <Routes>
          <Route path="/devwork" element={<RetroBackground />} />
          <Route path="/about" element={<AboutSection />} />
          <Route path="/resume" element={<Resume />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
